export default __webpack_public_path__ + "static/media/callFrom.9534074f.svg";